import styles from './poster.module.sass'

import Button from '../basic/button'
import Image from '../basic/image'

function Poster(props) {
	let fields = props.fields

	return <div className={styles.poster}>
		<h1>{fields.title}</h1>
		{fields.image?.url && <Image {...fields.image} />}
		<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>
		<Button fields={{button: {url: fields.attachment.url, title: 'Download', target: '_blank'}}} className={styles.button}>Download</Button>
	</div>
}

export default Poster